import { SuggestedMenu } from '../../Navbar/navbar.props'
import { BaseMenuItem } from '../MenuLayout.props'

export const navbarData: BaseMenuItem[] = [
  {
    menuName: 'Категории',
    menuDescription: '',
    menuUrl: '/action/v',
    menuImage:
      'https://production.hippoland-contents.com/platform/media/1440x600px_obsht-61405e0ec3165700116a5c37.jpg',
    menuImageLabel: 'Категории',
    menuImageLink: '/action/v',
    menuLabel: '',
    menuClass: 'category',
    disabled: false,
    nodes: [
      {
        menuName: 'Бебешки',
        menuDescription: '',
        menuUrl: '/produkti-bebeshki/c',
        menuImage: false,
        menuImageLabel: 'Топла точка',
        menuLabel: '',
        menuClass: '',

        columns: {
          col1: [
            {
              menuName: 'Бебешки колички',
              menuDescription: '',
              menuUrl: '/produkti-bebeshki-bebeshki-kolichki/c',
              menuClass: '',
            },
            {
              menuName: 'Обзавеждане за детска стая',
              menuDescription: '',
              menuUrl: '/produkti-bebeshki-bebeshki-krevatcheta-i-koshari/c',
              menuClass: '',
            },
            {
              menuName: 'Столчета за кола',
              menuDescription: '',
              menuUrl: '/produkti-bebeshki-stolcheta-za-kola/c',
              menuClass: '',
            },
            {
              menuName: 'Столчета за хранене',
              menuDescription: '',
              menuUrl: '/produkti-bebeshki-stolcheta-za-hranene/c',
              menuClass: '',
            },
            {
              menuName: 'Хранене и кърмене',
              menuDescription: '',
              menuUrl: '/produkti-bebeshki-hranene-i-karmene/c',
              menuClass: '',
            },
            {
              menuName: 'Уреди',
              menuDescription: '',
              menuUrl: '/produkti-bebeshki-uredi/c',
              menuClass: '',
            },
            {
              menuName: 'Продукти за баня и хигиена',
              menuDescription: '',
              menuUrl: '/produkti-bebeshki-produkti-za-banya-i-higiena/c',
              menuClass: '',
            },
          ],
          col2: [
            {
              menuName: 'Бебешки играчки',
              menuDescription: '',
              menuUrl: '/produkti-bebeshki-bebeshki-igrachki/c',
              menuClass: '',
            },
            {
              menuName: 'Кенгура и раници',
              menuDescription: '',
              menuUrl: '/produkti-bebeshki-prisposobleniya-za-nosene-na-bebe/c',
              menuClass: '',
            },
            {
              menuName: 'За прохождане',
              menuDescription: '',
              menuUrl:
                '/produkti-bebeshki-shezlongi-prohodilki-bandzhita-i-lyulki/c',
              menuClass: '',
            },
            {
              menuName: 'Шезлонги',
              menuDescription: '',
              menuUrl: '/produkti-bebeshki-shezlongi-i-lyulki/c',
              menuClass: '',
            },
            {
              menuName: 'Люлки',
              menuDescription: '',
              menuUrl: '/produkti-bebeshki-lyulki/c',
              menuClass: '',
            },
            {
              menuName: 'Комплекти за изписване ',
              menuDescription: '',
              menuUrl: '/produkti-bebeshki-komplekti-za-izpisvane/c',
              menuClass: '',
            },
          ],
        },
      },
      {
        menuName: 'Детски Играчки',
        menuDescription: '',
        menuUrl: '/produkti-detski-igrachki/c',
        menuImage: false,
        menuImageLabel: '',
        menuLabel: '',
        menuClass: '',
        columns: {
          col1: [
            {
              menuName: 'Детски оръжия',
              menuDescription: '',
              menuUrl: '/produkti-detski-igrachki-detski-orazhiya/c',
              menuClass: '',
            },
            {
              menuName: 'Детски столчета и масички',
              menuDescription: '',
              menuUrl:
                '/produkti-detski-igrachki-detski-stolcheta-i-masichki/c',
              menuClass: '',
            },
            {
              menuName: 'Дъски, маси и чинове',
              menuDescription: '',
              menuUrl:
                '/produkti-detski-igrachki-daski-za-pisane-i-magnitni-masi-i-chinove/c',
              menuClass: '',
            },
            {
              menuName: 'Играчки за предучилищна възраст',
              menuDescription: '',
              menuUrl:
                '/produkti-detski-igrachki-igrachki-za-detsa-preduchilistna-vazrast/c',
              menuClass: '',
            },
            {
              menuName: 'Интерактивни играчки',
              menuDescription: '',
              menuUrl: '/produkti-detski-igrachki-interaktivni-igrachki/c',
              menuClass: '',
            },
            {
              menuName: 'Конструктори и мозайки за деца',
              menuDescription: '',
              menuUrl: '/produkti-detski-igrachki-konstruktori-i-mozayki/c',
              menuClass: '',
            },
            {
              menuName: 'Компютри / Таблети',
              menuDescription: '',
              menuUrl: '/produkti-detski-igrachki-kompyutri-tableti/c',
              menuClass: '',
            },
            {
              menuName: 'Кукли',
              menuDescription: '',
              menuUrl: '/produkti-detski-igrachki-kukli/c',
              menuClass: '',
            },
            {
              menuName: 'Кухни и домакинско обзавеждане',
              menuDescription: '',
              menuUrl:
                '/produkti-detski-igrachki-kuhni-i-domakinsko-obzavejdane/c',
              menuClass: '',
            },
            {
              menuName: 'Музикални инструменти',
              menuDescription: '',
              menuUrl: '/produkti-detski-igrachki-muzikalni-instrumenti/c',
              menuClass: '',
            },
            {
              menuName: 'На открито',
              menuDescription: '',
              menuUrl:
                '/produkti-detski-igrachki-na-otkrito-lulki-parzalni-kasti/c',
              menuClass: '',
            },
            {
              menuName: 'Надуваеми артикули',
              menuDescription: '',
              menuUrl: '/produkti-detski-igrachki-naduvaemi-artikuli/c',
              menuClass: '',
            },
            {
              menuName: 'Направи си сам',
              menuDescription: '',
              menuUrl: '/produkti-detski-igrachki-napravi-si-sam/c',
              menuClass: '',
            },
          ],
          col2: [
            {
              menuName: 'Игри',
              menuDescription: '',
              menuUrl: '/produkti-detski-igrachki-igri/c',
              menuClass: '',
            },
            {
              menuName: 'Наука',
              menuDescription: '',
              menuUrl: '/produkti-detski-igrachki-obrazovatelni/c',
              menuClass: '',
            },
            {
              menuName: 'Плюшени играчки',
              menuDescription: '',
              menuUrl: '/produkti-detski-igrachki-plyusheni-igrachki/c',
              menuClass: '',
            },
            {
              menuName: 'Професии',
              menuDescription: '',
              menuUrl: '/produkti-detski-igrachki-profesii/c',
              menuClass: '',
            },
            {
              menuName: 'Пъзели',
              menuDescription: '',
              menuUrl: '/produkti-detski-igrachki-pazeli/c',
              menuClass: '',
            },
            {
              menuName: 'Спортни играчки',
              menuDescription: '',
              menuUrl: '/produkti-detski-igrachki-sportni/c',
              menuClass: '',
            },
            {
              menuName: 'Сезонни Лято/Зима',
              menuDescription: '',
              menuUrl: '/produkti-detski-igrachki-sezonni-lyato-zima/c',
              menuClass: '',
            },
            {
              menuName: 'Транспортни играчки',
              menuDescription: '',
              menuUrl: '/produkti-detski-igrachki-transportni-igrachki/c',
              menuClass: '',
            },
            {
              menuName: 'Фигури и игри',
              menuDescription: '',
              menuUrl: '/produkti-detski-igrachki-figuri-i-igri/c',
              menuClass: '',
            },
            {
              menuName: 'Карнавални костюми и артикули',
              menuDescription: '',
              menuUrl: '/produkti-detski-igrachki-parti-artikuli/c',
              menuClass: '',
            },
            {
              menuName: 'Батерии',
              menuDescription: '',
              menuUrl: '/produkti-detski-igrachki-baterii/c',
              menuClass: '',
            },
            {
              menuName: 'LEGO',
              menuDescription: '',
              menuUrl: '/produkti-detski-igrachki-lego/c',
              menuClass: '',
            },
          ],
        },
      },
      {
        menuName: 'Детски превозни средства',
        menuDescription: '',
        menuUrl: '/produkti-detski-prevozni-sredstva/c',
        menuImage: false,
        menuImageLabel: 'Топла точка',
        menuLabel: '',

        menuClass: '',

        columns: {
          col1: [
            {
              menuName: 'Акумулаторни коли и мотори',
              menuDescription: '',
              menuUrl:
                '/produkti-detski-prevozni-sredstva-akumulatorni-koli-i-motori/c',
              menuClass: '',
            },
            {
              menuName: 'Велосипеди',
              menuDescription: '',
              menuUrl: '/produkti-detski-prevozni-sredstva-velosipedi/c',
              menuClass: '',
            },
            {
              menuName: 'Коли и мотори с педали',
              menuDescription: '',
              menuUrl:
                '/produkti-detski-prevozni-sredstva-koli-i-motori-s-pedali/c',
              menuClass: '',
            },
            {
              menuName: 'Триколки',
              menuDescription: '',
              menuUrl: '/produkti-detski-prevozni-sredstva-trikolki/c',
              menuClass: '',
            },
          ],
          col2: [
            {
              menuName: 'Тротинетки - скутери',
              menuDescription: '',
              menuUrl:
                '/produkti-detski-prevozni-sredstva-trotinetki-skuteri/c',
              menuClass: '',
            },
            {
              menuName: 'Шейни',
              menuDescription: '',
              menuUrl: '/produkti-detski-prevozni-sredstva-sheyni/c',
              menuClass: '',
            },
            {
              menuName: 'Ride-on',
              menuDescription: '',
              menuUrl: '/produkti-detski-prevozni-sredstva-ride-on/c',
              menuClass: '',
            },
            {
              menuName: 'Колела за баланс',
              menuDescription: '',
              menuUrl: '/produkti-detski-prevozni-sredstva-kolela-za-balans/c',
              menuClass: '',
            },
          ],
        },
      },
      {
        menuName: 'Книги',
        menuDescription: '',
        menuUrl: '/produkti-knigi/c',
        menuImage: false,
        menuImageLabel: 'Топла точка',
        menuLabel: '',

        menuClass: '',

        columns: {
          col1: [
            {
              menuName: 'Занимателни книги',
              menuDescription: '',
              menuUrl: '/produkti-knigi-zanimatelni/c',
              menuClass: '',
            },
            {
              menuName: 'Книги за майката и бебето',
              menuDescription: '',
              menuUrl: '/produkti-knigi-knigi-za-maykata-i-bebeto/c',
              menuClass: '',
            },
            {
              menuName: 'Книжки за оцветяване',
              menuDescription: '',
              menuUrl: '/produkti-knigi-knizhki-za-otsvetyavane/c',
              menuClass: '',
            },
          ],
          col2: [
            {
              menuName: 'Книжки с игри и стикери',
              menuDescription: '',
              menuUrl: '/produkti-knigi-knizhki-s-igri-i-stikeri/c',
              menuClass: '',
            },
            {
              menuName: 'Образователни книги',
              menuDescription: '',
              menuUrl: '/produkti-knigi-obrazovatelni/c',
              menuClass: '',
            },
            {
              menuName: 'Детски книги',
              menuDescription: '',
              menuUrl: '/produkti-knigi-hudozhestvena-literatura/c',
              menuClass: '',
            },
          ],
        },
      },
      {
        menuName: 'За ученика',
        menuDescription: '',
        menuUrl: '/produkti-kantselarski-materiali/c',
        menuImage: false,
        menuImageLabel: 'Топла точка',
        menuLabel: '',

        menuClass: '',

        columns: {
          col1: [
            {
              menuName: 'Аксесоари',
              menuDescription: '',
              menuUrl: '/produkti-kantselarski-materiali-aksesoari/c',
              menuClass: '',
            },
            {
              menuName: 'Ученически пособия',
              menuDescription: '',
              menuUrl:
                '/produkti-kantselarski-materiali-uchenicheski-prinadlejnosti/c',
              menuClass: '',
            },
          ],
          col2: [
            {
              menuName: 'Материали за рисуване и моделиране',
              menuDescription: '',
              menuUrl:
                '/produkti-kantselarski-materiali-materiali-za-risuvane-i-modelirane/c',
              menuClass: '',
            },
            {
              menuName: 'Раници, чанти и несесери',
              menuDescription: '',
              menuUrl:
                '/produkti-kantselarski-materiali-ranitsi-chanti-i-neseseri/c',
              menuClass: '',
            },
          ],
        },
      },
      {
        menuName: 'Козметични комплекти и аксесоари',
        menuDescription: '',
        menuUrl: '/produkti-kozmetichni-komplekti-i-aksesoari/c',
        menuImage: false,
        menuImageLabel: 'Топла точка',
        menuLabel: '',

        menuClass: '',

        columns: {
          col1: [
            {
              menuName: 'Слънчеви очила',
              menuDescription: '',
              menuUrl: '/produkti-kozmetichni-komplekti-i-aksesoari/c',
              menuClass: '',
            },
          ],
        },
      },
      {
        menuName: 'Детски дрехи',
        menuDescription: '',
        menuUrl: '/produkti-obleklo/c',
        menuImage: false,
        menuImageLabel: 'Топла точка',
        menuLabel: '',

        menuClass: '',

        columns: {
          col1: [
            {
              menuName: 'Тениски и блузи',
              menuDescription: '',
              menuUrl: '/produkti-obleklo-teniski-i-bluzi/c',
              menuClass: '',
            },
            {
              menuName: 'Пуловери и жилетки',
              menuDescription: '',
              menuUrl: '/produkti-obleklo-puloveri-i-zhiletki/c',
              menuClass: '',
            },
            {
              menuName: 'Ризи',
              menuDescription: '',
              menuUrl: '/produkti-obleklo-rizi/c',
              menuClass: '',
            },
            {
              menuName: 'Рокли и поли',
              menuDescription: '',
              menuUrl: '/produkti-obleklo-rokli-i-poli/c',
              menuClass: '',
            },
          ],
          col2: [
            {
              menuName: 'Дънки, клинове и панталони',
              menuDescription: '',
              menuUrl: '/produkti-obleklo-danki-klinove-i-pantaloni/c',
              menuClass: '',
            },
            {
              menuName: 'Якета и палта',
              menuDescription: '',
              menuUrl: '/produkti-obleklo-yaketa-i-palta/c',
              menuClass: '',
            },
            {
              menuName: 'Бельо и чорапи',
              menuDescription: '',
              menuUrl: '/produkti-obleklo-belyo-i-chorapi/c',
              menuClass: '',
            },
          ],
        },
      },
    ],
  },
  {
    menuName: 'Акция',
    menuDescription: '',
    menuUrl: '/action/v',
    menuImage: false,
    menuImageLabel: 'Акция',
    menuImageLink:
      'https://www.hippoland.net/media/catalog/category/label-action-icon.svg',
    menuLabel: '',
    menuClass: 'sale',
    disabled: false,
  },
  {
    menuName: 'Топ Оферти',
    menuDescription: '',
    menuUrl: '/top-oferti/c',
    menuImage: false,
    menuImageLabel: 'Топ Оферти',
    menuImageLink: '#',
    menuLabel: '',
    menuClass: 'special',
    disabled: false,
  },
  {
    menuName: 'Най-ново',
    menuDescription: '',
    menuUrl: '/naj-novo/c',
    menuImage: false,
    menuImageLabel: 'Най-ново',
    menuImageLink: '#',
    menuLabel: '',
    menuClass: 'special',
    disabled: false,
  },
  {
    menuName: 'От ТВ Реклама',
    menuDescription: '',
    menuUrl: '/produkti-ot-tv-reklami/c',
    menuImage: false,
    menuImageLabel: 'От ТВ Реклама',
    menuImageLink: '#',
    menuLabel: '',
    menuClass: 'special',
    disabled: false,
  },
  {
    menuName: 'Марки',
    menuDescription: '',
    menuUrl: '/brands',
    menuImage: false,
    menuImageLabel: 'Марки',
    menuImageLink: '#',
    menuLabel: '',
    menuClass: 'special',
    disabled: false,
  },
  {
    menuName: 'Блог',
    menuDescription: '',
    menuUrl: '/blog',
    menuImage: false,
    menuImageLabel: 'Марки',
    menuImageLink: '#',
    menuLabel: '',
    menuClass: 'special',
    disabled: false,
  },
]

export const suggestedData: SuggestedMenu[] = [
  {
    menuName: 'Популярни търсения',
    items: [
      {
        label: 'Лего',
        url: '/lego/b',
      },
      {
        label: 'Baby Art',
        url: '/baby-art/b',
      },
      {
        label: 'BanBao',
        url: '/banbao/b',
      },
      {
        label: 'Barbie',
        url: '/barbie/b',
      },
      {
        label: 'Bebino',
        url: '/bebino/b',
      },
    ],
  },
  {
    menuName: 'Препоръчани категории',
    items: [
      {
        label: 'Играчки за предучилищна възраст',
        url:
          '/produkti-detski-igrachki-igrachki-za-detsa-preduchilistna-vazrast/c',
      },
      {
        label: 'Интерактивни играчки',
        url: '/produkti-detski-igrachki-interaktivni-igrachki/c',
      },
      {
        label: 'Конструктори и мозайки',
        url: '/produkti-detski-igrachki-konstruktori-i-mozayki/c',
      },
      {
        label: 'Кукли',
        url: '/produkti-detski-igrachki-kukli/c',
      },
      {
        label: 'Игри',
        url: '/produkti-detski-igrachki-igri/c',
      },
    ],
  },
]
